/**
 * Created by anthony on 11/20/14.
 */
var printableSummary = angular.module("printableSummary", ["classy"]);
